import React, { useRef } from 'react';
import { iphoneAppDownload, androidAppDownload, iphoneRedeemCode } from '../link-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faTabletAlt, faLaptop, faMobileAlt, faArrowCircleRight, faRedo,} from '@fortawesome/free-solid-svg-icons';
import LogoText from '../components/logoText';

export const LandingPage = (props) => {
    let promo = props.promo;
    let sportKey = props.sportKey;
    return (

        <div>
            <div className="non-landing-banner"></div>
            {props.banner}
            {(promo != null) ? <div className="container" >
                  <div className="row" style={{ border: "2px solid yellowgreen", backgroundColor: "#F1F8E4", margin: "5px", padding: "20px 0 20px 0", borderRadius: "10px" }}>
                      <div className="col-12 align-self-center text-center">
                          <h3 style={{fontSize:'26px', marginBottom: '4px', color: "yellowgreen"}}>{promo.name}</h3>
                          <h3 style={{fontSize:'20px'}}>TRY FREE FOR 90 DAYS</h3>
                          <a href="#" onClick={() => iphoneRedeemCode(promo.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                          <a href={`/promo/${promo.code}`}><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                          <div style={{ color: "#888888", fontSize: "12px" }}>Normally 7 days. Cancel any time. <br />Offer expires {promo.expiry}.</div>
                      </div>
                  </div>
              </div> :
              <div className="container" >
                  <div className="row" style={{ border: "2px solid yellowgreen", backgroundColor: "#F1F8E4", margin: "5px", padding: "20px 0 20px 0", borderRadius: "10px" }}>
                      <div className="col-12 align-self-center text-center">
                          <div style={{fontSize: '16px'}}>Try free for 7 days</div>
                          <div>
                              <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                              <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                          </div>

                      </div>
                  </div>
              </div>}

            {props.content}
            {(promo != null) && <section id="features" className="atf-pricing-area atf-section-padding">
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 atf-pricing-item">
                            <div className="atf-pricing-content wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s" data-wow-offset="0">
                                <div className="atf-pricing-heading">
                                    <div className="atf-pricing-name">
                                        <p style={{fontSize: '22px', color: 'yellowgreen', lineHeight: '1.6'}} className="offer-list-none">The best way to try <strong><LogoText /></strong> is with our</p>
                                        <h2 className="offer-list-none">{promo.name}</h2>
                                        <h4><a href={`/promo/${promo.code}`}>First 90 days free</a></h4>
                                        <h2 style={{fontSize: "18px", marginTop: "0px"}}>Then only US$7.99* <span style={{fontSize: '14px'}}>/year</span></h2>
                                    </div>
                                </div>
                                <div className="atf-pricing-body">
                                    <p>{promo.details}</p>
                                    <p style={{padding:"10px 0"}}>Cancel any time during the trial and pay nothing. Offer expires {promo.expiry}.</p>
                                    <a href="#" onClick={() => iphoneRedeemCode(promo.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                    <a href={`/promo/${promo.code}`}><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                                    <p style={{fontSize: "10px"}}>*Prices vary slightly per region.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            }

            <div id="get-started" className="atf-section-padding atf-footer-offset">
                <div className="atf-brand-overlay">
                    <div className="container">
                        <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                            <div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
                                {(promo != null) ? <><h2 className="mb-3 text-center">Don't like specials?</h2>
                                  <p style={{color: 'white', fontSize: '16px'}}>That's ok. Install the app normally here.</p></>
                                    :
                                    <h2 className="mb-3 text-center">Try for free today</h2>
                                }
                                <div>
                                    <a href="#none" onClick={() => iphoneAppDownload(`${sportKey}_video_bottom_cta`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                    <a href="#none" onClick={() => androidAppDownload(`${sportKey}_video_bottom_cta`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
